<template>
  <v-card
    :height="widgetHeight"
    :min-width="widgetWidth"
    class="ma-0 pa-0"
    :loading="loading"
    @mouseover.native="hover = true"
    @mouseleave.native="hover = false"
  >
    <v-card-title v-if="!loading" class="pa-0 ma-0">
      <widget-header :title="title" color="indigo" icon="mdi-chart-pie">
        <template slot="actions">
          <v-tooltip top v-if="enableEdit">
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                class="mr-2"
                v-show="hover"
                @click.prevent="refresh"
                >mdi-refresh</v-icon
              >
            </template>
            <span>{{ $t("Refresh") }}</span>
          </v-tooltip>
          <v-tooltip top v-if="enableEdit">
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                class="mr-2"
                v-show="hover"
                @click.prevent="removeWidget"
                >mdi-delete</v-icon
              >
            </template>
            <span>{{ $t("Delete") }}</span>
          </v-tooltip>
        </template>
      </widget-header>
    </v-card-title>
    <v-card-text class="pa-0 ma-0">
      <div
        v-if="!loading"
        :style="{
          'max-height': contentHeight + 'px',
          'max-width': contentWidth + 'px',
        }"
        class="overflow-y-auto ma-1 py-1"
      >
        <base-no-data v-if="!hasData && widgetHeight > 39" />
        <apexchart
          type="pie"
          :options="chartOptions"
          :series="series"
          v-if="hasData"
        ></apexchart>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import WidgetService from "@/services/WidgetService";
import WidgetHeader from "@/components/widgets/WidgetHeader";
import WidgetType from "@/ecm/variables/WidgetType";
import VueApexCharts from "vue-apexcharts";
import { mapGetters } from "vuex";

export default {
  components: { WidgetHeader, VueApexCharts, apexchart: VueApexCharts },
  name: "WidgetPieChart",
  props: {
    widgetId: {
      type: Number,
      default: 0,
    },
    enableEdit: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      default: 0,
    },
    height: { type: Number, default: 0 },
    width: { type: Number, default: 0 },
  },
  mounted() {
    this.widgetHeight = this.height;
    this.widgetWidth = this.width;
    this.refresh();

    this.connection = $.hubConnection(this.apiUrl);
    this.connection.qs = { access_token: this.token };
    var notificationHub = this.connection.createHubProxy("notificationHub");
    let self = this;
    notificationHub.on("refresh", (notifications) => {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(self.refresh, 5000);
    });
    this.connection.start();
  },
  destroyed() {
    if (this.connection) {
      this.connection.stop();
      this.connection = null;
    }
  },
  data() {
    return {
      connection: null,
      title: "",
      hover: false,
      loading: false,
      hasData: false,
      headerHeight: 66,
      widgetHeight: 0,
      widgetWidth: 0,
      chartOptions: {
        legend: {
          show: true,
          position: "bottom",
        },
        labels: [],
      },
      series: [],
    };
  },
  methods: {
    resize(height, width) {
      this.widgetHeight = height;
      this.widgetWidth = width;
    },
    refresh() {
      this.loading = true;

      WidgetService.getData({
        WidgetID: this.widgetId,
      }).then((widgetData) => {
        if (widgetData.length == 0) {
          this.hasData = false;
          this.loading = false;
          return;
        }

        if (this.widgetId == WidgetType.DocumentsByContentTypeChart) {
          this.title =
            this.$t("WidgetDocumentsByContentTypeTitle") +
            ": " +
            widgetData[0].Total;
        }
        if (this.widgetId == WidgetType.DocumentsByWorkflowChart) {
          this.title =
            this.$t("WidgetDocumentsByWorkflowTitle") +
            ": " +
            widgetData[0].Total;
        }

        const series = [];
        const labels = [];

        widgetData.forEach((element) => {
          series.push(element.SeriesValueY_AsDecimal);
          labels.push(element.SeriesValueX_AsString);
        });

        this.chartOptions.labels = labels;
        this.series = series;

        this.hasData = true;
        this.loading = false;
      });
    },
    removeWidget() {
      this.$emit("on-remove-widget", this.id);
    },
  },
  computed: {
    ...mapGetters({
      user: "account/user",
      apiUrl: "account/apiUrl",
      token: "account/token",
      userContentTypes: "account/userContentTypes",
    }),
    contentHeight() {
      return this.widgetHeight - this.headerHeight;
    },
    contentWidth() {
      return this.widgetWidth - 20;
    },
  },
};
</script>